/**
 * Created by jonas on 2021-02-17.
 */

import {gsap} from "gsap";

export class GSAPUtils {

    /**
     * Utility to ease transition from gsap 2 to gsap 3.
     *
     * Adding arrays of children to a timeline works a bit differently in gsap3 than gsap2.
     *
     * In gsap 2 you could stagger the children in the array like this:
     *
     * tl.add([anim1, anim2], 0, "start", 0.5);
     *
     * In the resulting Timeline "anim1" would start at 0,  and anim2 would start a 0.5 (0.5 seconds after the previous one (anim1) started);
     *
     *
     * With the new position system in gsap3 this does not work the same. The add function signature is now (child, position), with no staggering parameters.
     * So you might think that this would work:
     *
     * tl.add([anim1, anim2], "<0.5");
     *
     * But it doesn't. Because the add function will not loop though the list of children and add them one ofter another, theyy will just be added at the same time with the same delay.
     *
     *
     * @param timeline The timeline you want to add all the children to.
     * @param children Timeline children, i.e tweens, function calls etc.
     * @param position
     */
    public static addArrayToTimeline(timeline:gsap.core.Timeline, children:any[], position?:gsap.Position):gsap.core.Timeline {
        for(let child of children) {
            timeline.add(child, position);
        }
        return timeline;
    }

    public static createTimelineFromArray(children:any[], position?:gsap.Position):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        let first:boolean = true;
        for(let child of children) {
            if (child.paused != undefined && child.paused() == true){
                child.paused(false);
            }
            if (first){
                first = false;
                tl.add(child, 0);
            }else {
                tl.add(child, position);
            }
        }
        return tl;
    }
}